'use client';

import React from 'react'
import Image from '@src/components/atoms/safe-image';

import IconMinus from "@public/png/icon-minum.png"
import IconPlus from "@public/png/icon-plus.png"

const QuantityInput = ({
  min = 0,
  value,
  onChange,
  name,
  disabled
}) => {
  const handleDecrease = () => {
    if (+value >= min) {
      onChange(String(+value - 1), name);
    }
  };

  const handleIncrease = () => {
    onChange(String(+value + 1), name);
  };

  const handleChange = (e) => {
    let value = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters

    value = value === "" ? "0" : value;
    onChange(value, name)
  };

  return (
    <div className="flex items-center border border-solid border-[#E6E7E8] rounded-[8px] w-[120px] h-[40px]">
      <button
        className="h-full bg-white rounded-l-md w-[40px] flex items-center justify-center"
        onClick={handleDecrease}
        disabled={disabled}
      >
        <Image
          width={16}
          height={16}
          src={IconMinus}
          alt='Minus'
          className='object-contain'
        />
      </button>
      <input
        type="text"
        className="text-center outline-none border-x w-[40px] font-satoshi text-[17px] placeholder:text-[#808285]"
        value={value}
        placeholder='0'
        onChange={handleChange}
        name={name}
        disabled={disabled}
      />
      <button
        className="h-full bg-white rounded-r-md w-[40px] flex items-center justify-center"
        onClick={handleIncrease}
        disabled={disabled}
      >
        <Image
          width={16}
          height={16}
          src={IconPlus}
          alt='Plus'
          className='object-contain'
        />
      </button>
    </div>
  );
}

export default QuantityInput